/* eslint-disable class-methods-use-this */
/* eslint-disable import/extensions */
import { LitElement, html, css, isServer } from "lit";

class MySlider extends LitElement {
  static get styles() {
    return css`
      :host {
        display: block;
      }
      #slider {
        overflow: hidden;
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -moz-user-select: none; /* Firefox */
        user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */
        align-content: center;
      }
      #holder img {
        float: left;
      }
      #controls {
        position: absolute;
        z-index: 10;
      }
      .row {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .left,
      .right {
        background-color: #fff;
        overflow: hidden;
        width: 2em;
        height: 2em;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      #description {
        display: flex;
        z-index: 10;
      }
      #description div {
        background-color: rgb(63, 62, 62);
        color: #fff;
        height: 2.5em;
        line-height: 2.5em;
        padding-left: 0.5em;
      }
      #touch {
        border-radius: 50%;
        height: 2.5em;
        width: 2.5em;
        display: none;
        background-color: #fff;
        align-items: center;
        justify-content: center;
        animation: slide-slow 1.5s;
        animation-iteration-count: 3;
      }
      .left,
      .right {
        font-weight: bold;
      }

      .left[disabled],
      .right[disabled] {
        color: lightgray;
      }

      @keyframes slide-slow {
        from {
          margin-left: 0px;
        }
        to {
          margin-left: -100px;
        }
      }
      @media screen and (max-width: 414px) {
        #controls,
        #slider,
        #description,
        #holder img {
          width: 330px;
          height: 220px;
        }
        #holder {
          width: 990px;
        }
      }

      @media screen and (min-width: 415px) {
        #controls,
        #slider,
        #description,
        #holder img {
          width: 750px;
          height: 500px;
        }
        #holder {
          width: 2250px;
        }
      }
    `;
  }

  render() {
    return html`
      <div id="slider">
        <div id="controls">
          <div class="row">
            <div
              class="left"
              @click="${() => this.moveright()}"
              ?disabled="${this.i === 0}"
            >
              &lt;
            </div>
            <div id="touch"><mwc-icon>touch_app</mwc-icon></div>
            <div
              class="right"
              @click="${() => this.moveleft()}"
              ?disabled="${this.photos && this.i + 1 === this.photos.length}"
            >
              &gt;
            </div>
          </div>
        </div>

        <div class="holder" id="holder">
          <img src="/api/imageproxy/${this.getUrl(0)}@avif" fetchpriority="high"/>
        </div>
      </div>
      <div id="description">
        <div class="row">
          <div class="description">
            <div>${this.i + 1}/${this.photos?.length}</div>
          </div>
        </div>
      </div>
    `;
  }

  static get is() {
    return "my-slider";
  }

  static get properties() {
    return {
      photos: {
        type: Array,
      },
      animating: {
        type: Boolean,
      },
      i: {
        type: Number,
      },
      houseName: {
        type: String,
      },
    };
  }

  isTouchDevice() {
    return window.USER_IS_TOUCHING;
  }

  constructor() {
    super();
    this.animating = false;
    this.i = 0;
  }

  _render() {
    this.touchstartX = 0;
    this.touchendX = 0;
    if (window.matchMedia("(max-width: 414px)").matches) {
      this.width = 330;
    } else {
      this.width = 750;
    }
    // check if we have the elements already
    if (this.shadowRoot.getElementById("holder")) {
      this.animating = false;
      this.i = 0;

      // // we add the first image twice, but it can never be reached(!)
      this.addImageAtEnd(this.getUrl(0));

      setTimeout(() => {
        // focus on the middle element that we just added, but do it in a timeout to make sure it's really there already
        const myHolder = this.shadowRoot.getElementById("holder");
        myHolder.style.transform = `translate3d(-${this.width}px,0,0)`;
      }, 500);

      this.addImageAtEnd(this.getUrl(1));
    }

    this.shadowRoot.getElementById("slider").addEventListener(
      "touchstart",
      (e) => {
        this.touchstartX = e.changedTouches[0].screenX;
      },
      { passive: true }
    );

    this.shadowRoot.getElementById("slider").addEventListener(
      "touchend",
      (e) => {
        this.touchendX = e.changedTouches[0].screenX;
        this.checkDirection();
      },
      { passive: true }
    );
  }

  firstUpdated() {
    if (this.isTouchDevice()) {
      this.shadowRoot.getElementById("touch").style.display = "flex";
    }
    setTimeout(() => {
      this.shadowRoot.getElementById("touch").style.display = "none";
    }, 4680);
  }

  updated(changedProperties) {
    if (changedProperties.has("photos")) {
      if (this.photos) {
        this._render();
      }
    }
  }

  checkDirection() {
    if (this.touchendX < this.touchstartX) this.moveleft();
    if (this.touchendX > this.touchstartX) this.moveright();
    this.touchstartX = 0;
    this.touchendX = 0;
  }

  getUrl(index) {
    return this.photos[index].width600.URL;
  }

  removeLeftSide() {
    // cut left most image
    const holder = this.shadowRoot.getElementById("holder");
    holder.removeChild(holder.children[0]);
    holder.style.transition = "initial";
    holder.style.transform = `translate3d(-${this.width}px,0,0)`;
    let nextIndex;
    if (this.i === this.photos.length - 1) {
      nextIndex = this.photos.length - 1; // add the last image again to make sure we stay at 3 images
    } else {
      nextIndex = this.i + 1;
    }
    this.addImageAtEnd(this.getUrl(nextIndex));
    this.animating = false;
  }

  removeRightSide() {
    // cut right most image
    const holder = this.shadowRoot.getElementById("holder");
    holder.style.transition = "initial";
    holder.removeChild(holder.children[2]);
    holder.style.transform = `translate3d(-${this.width}px,0,0)`;
    let nextIndex;
    if (this.i === 0) {
      //  handle special case where we add the first image again to make sure we stay at 3 images
      nextIndex = 0;
    } else {
      nextIndex = this.i - 1;
    }
    this.addImageAddBeginning(this.getUrl(nextIndex));
    this.animating = false;
  }

  moveleft() {
    if (this.animating || this.i === this.photos.length - 1) {
      return;
    }
    const holder = this.shadowRoot.getElementById("holder");
    // eslint-disable-next-line no-plusplus
    this.i++;
    this.animating = true;
    const func = () => {
      holder.removeEventListener("transitionend", func);
      this.removeLeftSide();
    };
    holder.addEventListener("transitionend", func, false);
    holder.style.transition = "transform 0.3s ease-out";
    holder.style.transform = `translate3d(-${2 * this.width}px,0,0)`;
  }

  moveright() {
    if (this.animating || this.i === 0) {
      return;
    }
    const holder = this.shadowRoot.getElementById("holder");
    // eslint-disable-next-line no-plusplus
    this.i--;
    this.animating = true;
    holder.style.transition = "transform 0.3s ease-out";
    holder.style.transform = "translate3d(0px,0,0)";
    const func = () => {
      this.removeRightSide();
      holder.removeEventListener("transitionend", func);
    };
    holder.addEventListener("transitionend", func, false);
  }

  addImageAtEnd(image, addAlt) {
    const el = this.createImageElement(image, addAlt);
    const parent = this.shadowRoot.getElementById("holder");
    parent.appendChild(el);
  }

  addImageAddBeginning(image) {
    const el = this.createImageElement(image);
    const parent = this.shadowRoot.getElementById("holder");
    parent.insertBefore(el, parent.firstElementChild);
  }

  createImageElement(image, addAlt = false) {
    const el = document.createElement("img");
    el.src = `/api/imageproxy/${image}@avif`;
    if (addAlt) el.setAttribute("alt", this.houseName);
    return el;
  }
}
globalThis.customElements.define(MySlider.is, MySlider);
